import { render, staticRenderFns } from "./lrRichDg.vue?vue&type=template&id=3bc502ce&scoped=true&"
import script from "./lrRichDg.vue?vue&type=script&lang=js&"
export * from "./lrRichDg.vue?vue&type=script&lang=js&"
import style0 from "./lrRichDg.vue?vue&type=style&index=0&id=3bc502ce&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc502ce",
  null
  
)

export default component.exports